import { createSelector } from '@ngrx/store';
import { IBaseTab, ITabDashboard, ITabReport } from '../model/report-tabs.model';

// Feature selector - using direct path instead of createFeatureSelector
export const getTabsState = (state: any) => state.tabs;

// Basic selectors
export const selectTabIds = createSelector(getTabsState, state => (state && state.ids ? state.ids : []));

export const selectTabEntities = createSelector(getTabsState, state => (state && state.entities ? state.entities : {}));

export const selectAllTabs = createSelector(selectTabIds, selectTabEntities, (ids: string[], entities: { [id: string]: IBaseTab<ITabReport | ITabDashboard> }) => {
    if (!ids || !entities) return [];
    return ids.map(id => entities[id]).filter(tab => !!tab) as IBaseTab<ITabReport | ITabDashboard>[];
});

export const selectCurrentTabId = createSelector(getTabsState, state => (state ? state.selectedReportTabId : null));

export const selectCurrentTab = createSelector(selectTabEntities, selectCurrentTabId, (tabEntities, tabId) => (tabId && tabEntities ? tabEntities[tabId] : null));

export const getTabInfo = createSelector(getTabsState, state => (state ? state.tabInfo : {}));

export const getTabInfoById = (id: string) => createSelector(selectAllTabs, tabs => tabs.find(tab => tab.tabId === id));

export const getLastTab = createSelector(selectTabIds, tabIds => (tabIds && tabIds.length > 0 ? tabIds[tabIds.length - 1] : null));

export const selectAllTabNames = createSelector(selectAllTabs, tabs => tabs.map(t => t?.content?.name || ''));
